// src/utils/statusConfig.js
import React from 'react';
import {
  CheckCircle as DoneIcon,
  DirectionsRun as InProgressIcon,
  RateReview as ReviewIcon,
  Cancel as CancelledIcon,
  RadioButtonUnchecked as TodoIcon,
  Schedule as PlanningIcon,
  PlayArrow as ActiveIcon,
  Pause as HoldIcon,
  Edit as DraftIcon,
  Campaign as CampaignIcon
} from '@mui/icons-material';

// Campaign status configuration
export const campaignStatusConfig = {
  draft: {
    label: 'Draft',
    color: 'default',
    icon: <DraftIcon fontSize="small" />
  },
  planning: {
    label: 'Planning',
    color: 'info',
    icon: <PlanningIcon fontSize="small" />
  },
  active: {
    label: 'Active',
    color: 'success',
    icon: <ActiveIcon fontSize="small" />
  },
  paused: {
    label: 'Paused',
    color: 'warning',
    icon: <HoldIcon fontSize="small" />
  },
  completed: {
    label: 'Completed',
    color: 'primary',
    icon: <DoneIcon fontSize="small" />
  },
  cancelled: {
    label: 'Cancelled',
    color: 'error',
    icon: <CancelledIcon fontSize="small" />
  }
};

// Client status configuration
export const clientStatusConfig = {
  active: { color: 'success', label: 'Active' },
  inactive: { color: 'error', label: 'Inactive' },
  onboarding: { color: 'warning', label: 'Onboarding' },
  paused: { color: 'info', label: 'Paused' },
  former: { color: 'default', label: 'Former' }
};

// Brand status configuration  
export const brandStatusConfig = {
  active: { color: 'success', label: 'Active' },
  inactive: { color: 'error', label: 'Inactive' },
  draft: { color: 'default', label: 'Draft' }
};

// Task status configuration
export const taskStatusConfig = {
  to_do: { 
    color: 'default', 
    label: 'To Do',
    icon: <TodoIcon fontSize="small" />
  },
  in_progress: { 
    color: 'info', 
    label: 'In Progress',
    icon: <InProgressIcon fontSize="small" />
  },
  in_review: { 
    color: 'warning', 
    label: 'In Review',
    icon: <ReviewIcon fontSize="small" />
  },
  done: { 
    color: 'success', 
    label: 'Done',
    icon: <DoneIcon fontSize="small" />
  },
  cancelled: { 
    color: 'error', 
    label: 'Cancelled',
    icon: <CancelledIcon fontSize="small" />
  }
};

// Project status configuration
export const projectStatusConfig = {
  draft: {
    label: 'Draft',
    color: 'default',
    icon: <DraftIcon fontSize="small" />
  },
  planning: {
    label: 'Planning',
    color: 'info',
    icon: <PlanningIcon fontSize="small" />
  },
  active: {
    label: 'Active',
    color: 'success',
    icon: <ActiveIcon fontSize="small" />
  },
  on_hold: {
    label: 'On Hold',
    color: 'warning',
    icon: <HoldIcon fontSize="small" />
  },
  completed: {
    label: 'Completed',
    color: 'primary',
    icon: <DoneIcon fontSize="small" />
  },
  cancelled: {
    label: 'Cancelled',
    color: 'error',
    icon: <CancelledIcon fontSize="small" />
  }
};

// Region configuration with flag emojis
export const regionConfig = {
  'Egypt': { color: '#E23D28', icon: '🇪🇬' },
  'Saudi Arabia': { color: '#01401C', icon: '🇸🇦' },
  'Qatar': { color: '#8D1B3D', icon: '🇶🇦' },
  'UAE': { color: '#00732F', icon: '🇦🇪' },
  'Kuwait': { color: '#007A3D', icon: '🇰🇼' },
  'Bahrain': { color: '#CE1126', icon: '🇧🇭' },
  'Oman': { color: '#C8102E', icon: '🇴🇲' },
  'Other': { color: '#666666', icon: '🌍' }
};

// Priority configuration
export const priorityConfig = {
  urgent: { color: 'error', label: 'Urgent' },
  high: { color: 'warning', label: 'High' },
  medium: { color: 'info', label: 'Medium' },
  low: { color: 'success', label: 'Low' }
};

// Get status configuration based on entity type and status value
export const getStatusConfig = (entityType, status) => {
  switch (entityType) {
    case 'client':
      return clientStatusConfig[status] || { color: 'default', label: status };
    case 'brand':
      return brandStatusConfig[status] || { color: 'default', label: status };
    case 'task':
      return taskStatusConfig[status] || { color: 'default', label: status };
    case 'project':
      return projectStatusConfig[status] || { color: 'default', label: status };
    case 'campaign':
      return campaignStatusConfig[status] || { color: 'default', label: status };
    default:
      return {
        color: 'default',
        label: status ? status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ') : 'Unknown'
      };
  }
};

// Get region configuration
export const getRegionConfig = (region) => {
  return regionConfig[region] || regionConfig.Other;
};

// Get priority configuration
export const getPriorityConfig = (priority) => {
  return priorityConfig[priority] || { color: 'default', label: priority };
};